import { useTranslation } from 'react-i18next';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getMainSetting } from 'src/shared/functions/getMainSetting';
import { MainSettingsEnum } from 'src/shared/models/enums/mainSettings.enum';

/**
 * Kundens benämning på vänmedlemskap. Kunden kan döpa om funktionen i
 * medlemsregisterinställningarna, och då ska alla vyer följa med.
 *
 * Inställningarna finns på både användaren och medlemmen. På Min sida är bara currentMember
 * satt, och där föll benämningen tidigare tillbaka på det hårdkodade ordet.
 */
export const useExtraMembershipLabel = () => {
  const { t } = useTranslation(['member']);
  const { currentUser, currentMember } = useGlobals();

  const settings = currentUser?.mainSettings ?? currentMember?.mainSettings ?? [];

  return getMainSetting(settings, MainSettingsEnum.NewFriendLabel, '') || t('member:extraMembership.header');
};

export default useExtraMembershipLabel;
